import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFaceCallVideoMutationVariables = Types.Exact<{
  songId: Types.Scalars['Int']['input'];
  performerId: Array<Types.Club_WorldFamilyClub_FaceCallSongAndPerformerInput> | Types.Club_WorldFamilyClub_FaceCallSongAndPerformerInput;
  vimeoId: Types.Scalars['String']['input'];
  themeId: Types.Scalars['Int']['input'];
}>;


export type CreateFaceCallVideoMutation = { __typename?: 'Mutation', club_worldFamilyClub: { __typename?: 'Club_WorldFamilyClub_Mutation_Payload', count: number } };


export const CreateFaceCallVideoDocument = gql`
    mutation CreateFaceCallVideo($songId: Int!, $performerId: [Club_WorldFamilyClub_FaceCallSongAndPerformerInput!]!, $vimeoId: String!, $themeId: Int!) {
  club_worldFamilyClub(
    add: {faceCallSong: {teSongId: $songId, faceCallSongAndPerformers: $performerId, vimeoVideoId: $vimeoId, faceCallSeasonHolidayId: $themeId}}
  ) {
    count
  }
}
    `;
export type CreateFaceCallVideoMutationFn = Apollo.MutationFunction<CreateFaceCallVideoMutation, CreateFaceCallVideoMutationVariables>;

/**
 * __useCreateFaceCallVideoMutation__
 *
 * To run a mutation, you first call `useCreateFaceCallVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaceCallVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaceCallVideoMutation, { data, loading, error }] = useCreateFaceCallVideoMutation({
 *   variables: {
 *      songId: // value for 'songId'
 *      performerId: // value for 'performerId'
 *      vimeoId: // value for 'vimeoId'
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useCreateFaceCallVideoMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaceCallVideoMutation, CreateFaceCallVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaceCallVideoMutation, CreateFaceCallVideoMutationVariables>(CreateFaceCallVideoDocument, options);
      }
export type CreateFaceCallVideoMutationHookResult = ReturnType<typeof useCreateFaceCallVideoMutation>;
export type CreateFaceCallVideoMutationResult = Apollo.MutationResult<CreateFaceCallVideoMutation>;
export type CreateFaceCallVideoMutationOptions = Apollo.BaseMutationOptions<CreateFaceCallVideoMutation, CreateFaceCallVideoMutationVariables>;